"use client";

import { useState } from "react";
import Link from "next/link";
import { Logo } from "./Logo";
import { Button } from "./Button";

const NAV = [
  { href: "/modules/", label: "Compliance modules" },
  { href: "/how-it-works/", label: "How it works" },
  { href: "/tools/", label: "Free tools" },
  { href: "/guides/", label: "Guides" },
  { href: "/pricing/", label: "Pricing" },
];

export function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 border-b border-line/85 bg-paper/85 backdrop-blur-[18px] backdrop-saturate-150">
      <div className="mx-auto flex h-[68px] max-w-7xl items-center justify-between px-5">
        <Logo />
        <nav className="hidden items-center gap-7 lg:flex" aria-label="Primary">
          {NAV.map((l) => (
            <Link key={l.href} href={l.href} className="text-[14px] font-semibold text-[#536170] hover:text-ink">
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Button href="/#signup" variant="primary" className="hidden sm:inline-flex">
            Get early access
          </Button>
          <button
            type="button"
            className="grid h-[42px] w-[42px] place-items-center rounded-[8px] border border-line bg-white text-ink lg:hidden"
            aria-label="Toggle menu"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
              {open ? <path d="M6 6l12 12M18 6 6 18" /> : <path d="M4 7h16M4 12h16M4 17h16" />}
            </svg>
          </button>
        </div>
      </div>
      {open && (
        <div className="grid gap-1 border-t border-line-soft bg-white px-5 pb-5 pt-2.5 lg:hidden">
          {NAV.map((l) => (
            <Link key={l.href} href={l.href} className="px-1 py-2.5 font-semibold text-[#536170]" onClick={() => setOpen(false)}>
              {l.label}
            </Link>
          ))}
          <Button href="/#signup" variant="primary" className="mt-2">
            Get early access
          </Button>
        </div>
      )}
    </header>
  );
}
